import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient } from '@/app/shared/services/http-client/http-client.js';
export class MedicalHistoryService {
 
    GetObsGynLookup( patientId,callback, errCallback) {
        debugger
        httpClient.get(modelServices.baseUrl + modelServices.getMedicalHistoryModuleSeviceName("GetObsGynInitData").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    GetMedicationInitData(patientId, callback, errCallback) {
        debugger
        httpClient.get(modelServices.baseUrl + modelServices.getMedicalHistoryModuleSeviceName("GetMedicationInitData").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    GetFamilyHistoryInitData(patientId, callback, errCallback) {
        debugger
        httpClient.get(modelServices.baseUrl + modelServices.getMedicalHistoryModuleSeviceName("GetFamilyHistoryInitData").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    SetPatientMedicalHistory(patientModel, callback, errCallback) {
        debugger
        const url = modelServices.baseUrl + modelServices.getMedicalHistoryModuleSeviceName("SetPatientMedicalHistory").URL;
        const options = {
            url: url,
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            data: JSON.stringify(patientModel)
        };
        httpClient(options).then(callback).catch(errCallback);
    }
    GetPatientSocialHistoryData(patientId, callback, errCallback) {
        debugger;
        httpClient.get(modelServices.baseUrl + modelServices.getMedicalHistoryModuleSeviceName("GetPatientSocialHistoryData").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    GetPatientSurgicalHistory(patientId, callback, errCallback) {
        debugger
        httpClient.get(modelServices.baseUrl + modelServices.getMedicalHistoryModuleSeviceName("GetPatientSurgicalHistory").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    
}
const medicalhistoryService = new MedicalHistoryService();

export { medicalhistoryService };